import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import { usePaymentsContext } from "../../context/usePaymentsContext";
import { openInNewTab } from "../../helper/Utils";

const StripePlan = ({ style, plan }) => {
  return (
    <Container style={style}>
      <MuaSegment>
        <ContainerForMAUsLeft>
          <h2>MAUs for the Current Billing Cycle</h2>
          <h3
            onClick={() =>
              openInNewTab(
                "https://docs.grovs.io/s/b23802f1-a6e2-4ba4-a3fe-301bcf442c04/doc/what-are-monthly-active-users-muas-ppVem0oSLY"
              )
            }
          >
            What is MAU?
          </h3>
        </ContainerForMAUsLeft>

        <ContainerForMAUs style={{ marginLeft: "auto" }}>
          <h1>
            {new Intl.NumberFormat("de-DE").format(
              plan.quantity_for_current_billing_cycle
            )}
          </h1>
          <span>Monthly Active Users (MAU)</span>
        </ContainerForMAUs>
      </MuaSegment>
    </Container>
  );
};

export default StripePlan;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 760px;
`;

const ContainerForMAUs = styled.div`
  display: flex;
  flex-direction: column; /* Stack the count and MAU vertically */
  gap: 5px; /* Adds some spacing between the count and the MAU text */
  text-align: right; /* Align the text to the right */
`;

const ContainerForMAUsLeft = styled.div`
  display: flex;
  flex-direction: column; /* Stack the count and MAU vertically */
  gap: 5px; /* Adds some spacing between the count and the MAU text */
  text-align: left; /* Align the text to the right */
`;

const MuaSegment = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row; /* Stack the title and the count+MAU vertically */
  justify-content: center;

  h1 {
    color: ${lightThemeColors.darkColorFaded};
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.02em;
    text-align: right; /* Align text to the right */
  }

  span {
    min-width: 180px;
    font-size: 14px;
    font-weight: 500;
    color: ${lightThemeColors.darkColorFaded30};
  }

  h2 {
    color: ${lightThemeColors.darkColorFaded};
    font-size: 16px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0.02em;
  }

  h3 {
    width: inherit !important;
    cursor: pointer;
    color: ${lightThemeColors.primaryColor};
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
  }
`;

const InfoTextWrapper = styled.div`
  display: flex;
  gap: 5px;
  p {
    color: ${lightThemeColors.darkColorFaded30};
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
  }
  h3 {
    color: ${lightThemeColors.authentication.inputErrorColor};
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
  }
  h2 {
    width: inherit !important;
    cursor: pointer;
    color: ${lightThemeColors.primaryColor};
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
  }
`;
